import React from 'react';
import Menu from '../../../components/Menu/Menu';
import MyHead from '../../../components/MyHead';
import Footer from '../../../components/Footer';
import LoginPresentational from '../../../components/Profile/LoginPresentational';
import { login } from '../../../fetchers/login';
import { useCookies } from 'react-cookie';
import { useState } from 'react';
import { useRouter } from 'next/router';
import { useAlert } from '../../../context/AlertProvider';
import { useTranslation } from 'react-i18next';
import { getLangCountry } from '../../../helpers/languages';
import { fetchProfileSettings } from '../../../fetchers/profile';
import { useStore } from 'react-redux';
import { SET_PROFILE } from '../../../context/types';

const Login = () => {
  const router = useRouter();
  const [cookies, setCookie] = useCookies([
    'jeep_bearer',
    'jeep_authenticated'
  ]);
  const [loading, setLoading] = useState(false);
  const alert = useAlert();
  const { t } = useTranslation();
  const store = useStore();
  const { lang, country } = getLangCountry(router.query);

  const onLogin = async (values: {
    email: string;
    password: string;
  }): Promise<void> => {
    const { email, password } = values;

    setLoading(true);

    const { data, error } = await login({
      email,
      password,
      session_token: cookies['jeep_bearer']
    });

    if (error) {
      alert.error(t(error.response?.data?.message || 'GENERIC_ERROR'));
      setLoading(false);
      return;
    }

    const { token } = data;
    setCookie('jeep_bearer', token, { path: '/' });
    setCookie('jeep_authenticated', true, { path: '/' });

    if (token) {
      const { error: errorMe, data: dataMe } = await fetchProfileSettings({
        lang,
        country,
        token
      });
      if (!errorMe) {
        store.dispatch({ type: SET_PROFILE, payload: dataMe.user_info });
      }
    }
    setLoading(false);

    router.push(`/${lang}_${country}/profile/home`);
  };

  return (
    <>
      <MyHead />
      <div>
        <Menu />
        <LoginPresentational onLogin={onLogin} loading={loading} />
        <Footer />
      </div>
    </>
  );
};

export default Login;
